import { OptionsObject, SnackbarMessage, useSnackbar } from "notistack";
import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { clearAlerts } from "reducers/alerts";

// Define variant types for notistack v3 (no longer using MUI AlertColor)
type VariantType = "default" | "error" | "success" | "warning" | "info";

const useAlert = () => {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const dispatch = useDispatch();

  const showAlert = useCallback(
    (
      variant: VariantType,
      message: SnackbarMessage,
      option?: OptionsObject
    ) => {
      enqueueSnackbar(message, {
        ...option,
        variant,
        preventDuplicate: true,
        onClose: () => {
          dispatch(clearAlerts());
        },
      });
    },
    [enqueueSnackbar, dispatch]
  );

  return { showAlert };
};

export default useAlert;
